import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTender from "./ViewTender/ViewTender.jsx";
import ViewApprovers from "./ViewTender/ViewApprovers.jsx";
import ViewBidOpeners from "./ViewTender/ViewBidOpeners.jsx";
import Modal from "@mui/material/Modal";
import ErrorModal from "../../utils/ErrorModal.jsx";
import { handleExportPDF } from "../../utils/exportToPDF.js";
import AwardedPDF from "./AwardedPDF.jsx";
import { useDownloadExcel } from "react-export-table-to-excel";
import ViewAllBidsExportExcel from "./PurchaseHead/ViewAllBidsExportExcel.jsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SingleTender = () => {
  const pdfRef = useRef();
  const awardRef = useRef();
  const [tender, setTender] = useState();
  const [workItems, setWorkItems] = useState();
  const { tenderId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [status, setStatus] = useState();
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [awarded, setAwarded] = useState();
  const [exporting, setExporting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const tableRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [groupedData, setGroupedData] = useState();
  const [exportingExcel, setExportingExcel] = useState(false);

  const { onDownload } = useDownloadExcel({
    currentTableRef: groupedData && tableRef.current,
    filename: "Bids Comparison",
    sheet: "Bids Comparison",
  });

  const handleOpen = (s) => {
    setOpen(true);
    setStatus(s);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenError(false);
    setErrorMsg();
    setStatus("");
    setReason("");
  };
  

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(reason)) newErrors.reason = "Reason is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails);
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getTender();
  }, []);

  useEffect(() => {
    const getAwarded = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/awarded?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setAwarded(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getAwarded();
  }, [tender]);

  useEffect(() => {
    const getBidData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/get-award-tender-bid?tenderId=${tenderId}&username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        const allBids = res.data.filter(Boolean);
        setGroupedData(groupBidsByVendor(allBids) || null);
      } catch (error) {
        console.log(error);
      }
    };

    getBidData();
  }, [awarded]);

  const groupedWorkItems = workItems?.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const groupBidsByVendor = (bids) => {
    const grouped = {};
    bids.forEach((bid) => {
      const name = bid.vendor.name;
      if (!grouped[name]) {
        grouped[name] = [];
      }
      grouped[name].push(bid);
    });
    return grouped;
  };

  const handleBack = () => {
    if (location.pathname.includes("tender")) {
      navigate(`/dashboard/${tenderId}`);
    } else if (localStorage.getItem("action")) {
      navigate(`/dashboard/pending-actions`);
    } else if (localStorage.getItem("activeTab")) {
      navigate(`/dashboard`);
    }
  };

  const handleTenderUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/tender`,
        [
          {
            username: storedUser.username,
            tenderId: tender.tenderId,
            status: status,
            reason: reason,
          },
        ],
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/dashboard");
    } catch (error) {
      setOpen(false);
      setOpenError(true);
      setErrorMsg(error.response.data.Exception);
    } finally {
      setBtnLoading(false);
    }
  };

  let totalAmount = 0;

  return (
    <div style={{ position: "relative" }}>
      {exporting && (
        <div className="uploading-div">
          Exporting PDF, this may take a while.{" "}
          <CircularProgress color="#fff" />
        </div>
      )}
      {btnLoading && <div className="loading-div"></div>}
      {tender && (
        <div>
          <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
            {awarded && (
              <>
              <Button
                className="btn-contained"
                onClick={async () => {
                  try {
                    setExporting(true);
                    await handleExportPDF(awardRef, "Tender_Awarded");
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setExporting(false);
                  }
                }}
              >
                Export Awarded PDF
              </Button>
            <Button
              className="btn-contained"
              style={{ width: "auto" }}
              onClick={async () => {
                if (!tableRef.current) {
                  console.warn("Excel table not ready yet");
                  return;
                }
                try {
                  setExportingExcel(true);
                  onDownload();
                } catch (error) {
                  console.log(error);
                } finally {
                  setExportingExcel(false);
                }
              }}
            >
              Export Comparatives Excel
            </Button>
              </>
            )}
            <Button
              className="btn-contained"
              style={{ width: "auto" }}
              onClick={async () => {
                try {
                  setExporting(true);
                  await handleExportPDF(pdfRef, "Tender_Details");
                } catch (error) {
                  console.log(error);
                } finally {
                  setExporting(false);
                }
              }}
            >
              Export Tender Details PDF
            </Button>
          </div>
          <div ref={pdfRef} className="tender-components">
            <ViewTender
              tender={tender}
              workItems={workItems}
              groupedWorkItems={groupedWorkItems}
              storedUser={storedUser}
            />
            <ViewApprovers tender={tender} />
            <ViewBidOpeners tender={tender} />
          </div>
          {awarded ? (
            <Box
              className="dashboard-container"
              key={awarded.vendor.vendorId}
              px={10}
            >
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Vendor: {awarded.vendor.name} ({awarded.vendor.firmName})
              </Typography>

              {/* <Box mb={2}>
                  <Typography
                    className="form-title"
                    sx={{ fontWeight: "bold", mb: 1 }}
                  >
                    Technical Specification Files:
                  </Typography>

                  {[...Array(8)].map((_, index) => {
                    const tsKey = `ts${index + 1}`;
                    const tsFilenameKey = `ts${index + 1}Filename`;
                    const file = awarded[tsKey];

                    if (file) {
                      return (
                        <Grid2
                          key={index}
                          container
                          sx={{
                            borderTop: "1px solid #000",
                            borderRight: "1px solid #000",
                          }}
                        >
                          <Grid2
                            size={{ xs: 12, sm: 6 }}
                            className="preview-grid"
                            sx={{ borderTop: "1px solid #000" }}
                          >
                            TS-{index + 1}
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6 }}
                            className="preview-grid"
                            sx={{
                              borderTop: "1px solid #000",
                              borderRight: "1px solid #000",
                            }}
                          >
                            <Button
                              sx={{
                                margin: "0 !important",
                                padding: "0 !important",
                                width: "max-content !important",
                                fontSize: "12px !important",
                                textDecoration: "underline",
                                textAlign: "start",
                              }}
                              onClick={() => viewPDF(file, storedUser)}
                            >
                              View
                            </Button>
                          </Grid2>
                        </Grid2>
                      );
                    }

                    return null;
                  })}
                </Box> */}
              <table
                border={1}
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th style={{ padding: "20px" }}>Item Name</th>
                    <th>Description</th>
                    <th>Section</th>
                    <th>Unit</th>
                    <th>Quantity</th>
                    <th>Rate (in ₹)</th>
                    <th>Total (in ₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {awarded.bidWorkItems
                    .filter((bw) => awarded.bidStatus === "AWARDED")
                    .sort((a, b) => a.itemOrder - b.itemOrder)
                    .map((bw) => {
                      totalAmount += bw.quantity * bw.rate || 0;
                      return (
                        <tr key={bw.bwId} style={{ textAlign: "center" }}>
                          <td style={{ padding: "20px" }}>{bw.itemName}</td>
                          <td>{bw.description}</td>
                          <td>{bw.section}</td>
                          <td>{bw.unit}</td>
                          <td>{bw.quantity}</td>
                          <td>{bw.rate.toFixed(2)}</td>
                          <td>{(bw.quantity * bw.rate).toFixed(2)}</td>
                        </tr>
                      );
                    })}
                  <tr
                    style={{ fontWeight: "bold", backgroundColor: "#e0f7fa" }}
                  >
                    <td
                      colSpan={6}
                      style={{ padding: "20px", textAlign: "right" }}
                    >
                      Grand Total (in ₹):
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {totalAmount.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          ) : null}
          {awarded && groupedData && (
            <div
              ref={awardRef}
              style={{
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
                height: "auto",
                width: "auto",
                paddingInline: "5px",
              }}
            >
              <AwardedPDF
                tender={tender}
                awarded={awarded}
                groupedWorkItems={groupedWorkItems}
                groupedData={groupedData}
              />
            </div>
          )}
          {awarded && groupedData && (
            <Box ref={tableRef} sx={{ display: "none" }}>
              <ViewAllBidsExportExcel
                groupedWorkItems={groupedWorkItems}
                groupedData={groupedData}
                storedUser={storedUser}
              />
            </Box>
          )}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              sx={{ border: "1px solid #1A71F6 !important" }}
              onClick={handleBack}
            >
              Back
            </Button>
            {storedUser.userRole[0] === "PURCHASE_HEAD" &&
              tender.status === "REVIEW" && (
                <>
                  <Button
                    className="btn-outlined"
                    onClick={() => handleOpen("REWORK")}
                  >
                    Rework
                  </Button>
                  <Button
                    className="btn-outlined btn-reject"
                    onClick={() => handleOpen("REJECTED")}
                  >
                    Reject
                  </Button>
                  <Button
                    className="btn-contained"
                    onClick={() => handleOpen("UPCOMING")}
                  >
                    Approve
                  </Button>
                </>
              )}
          </Box>
        </div>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {status === "UPCOMING"
              ? "Approve"
              : status === "REWORK"
              ? "Rework"
              : "Reject"}{" "}
            the Tender
          </Typography>
          <label htmlFor="reason">
            Please give reason for{" "}
            {status === "UPCOMING"
              ? "Approv"
              : status === "REWORK"
              ? "Rework"
              : "Reject"}
            ing the tender*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value);
              setErrors({ reason: "" });
            }}
            rows={8}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn-contained"
              onClick={handleTenderUpdate}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting" : "Submit"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <ErrorModal open={openError} handleClose={handleClose} msg={errorMsg} />
    </div>
  );
};

export default SingleTender;
